import { Icon } from "@src/components/ui-kit/Icon";
import { UncollapseOnHover } from "@src/components/ui-kit/UncollapseOnHover";
import type { FC, PropsWithChildren } from "react";

export const LinkIconOnHover: FC<
  PropsWithChildren<{ dataComponentName: string }>
> = ({ children, dataComponentName }) => {
  return (
    <UncollapseOnHover
      width="4"
      dataComponentName={dataComponentName}
      hiddenComponent={<Icon name="link-external-01" w="4" h="4" />}
    >
      {children}
    </UncollapseOnHover>
  );
};
